import { render, staticRenderFns } from "./deliveryLocationManage.vue?vue&type=template&id=519fba41"
import script from "./deliveryLocationManage.vue?vue&type=script&lang=js"
export * from "./deliveryLocationManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports